(function($) {
    "use strict";

    // Function to convert hex format to a rgb color
    function rgb2hex(rgb){
        rgb = rgb ?? "000000";
        rgb = rgb.match(/^rgba?[\s+]?\([\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?,[\s+]?(\d+)[\s+]?/i);
        return (rgb && rgb.length === 4) ? "#" +
        ("0" + parseInt(rgb[1],10).toString(16)).slice(-2) +
        ("0" + parseInt(rgb[2],10).toString(16)).slice(-2) +
        ("0" + parseInt(rgb[3],10).toString(16)).slice(-2) : '';
    }

    // Function to generate inverted hex
    function invertHex(hex) {
        return (Number(`0x1${hex}`) ^ 0xFFFFFF).toString(16).substr(1).toUpperCase()
    }

    $(function() {
        $('section').addClass("accessibility");

        $('.js-open-search').on('keyup', function(e) {
            if(e.which == 13) {
                $('.js-search-input').addClass('open');
                $('.js-search-input').trigger('focus');
            }
            if(e.which == 9) {
                $('.js-search-input').removeClass('open');
                $('.js-search-input').trigger('blur');
            }
        });

        $('.accessibility').each(function(i, item) {
            let first_h = false;
            for (let i = 1; i < 7; i++) {
                if ($(this).find("h" + i).length > 0) {
                    $(this).find("h" + i).attr("tabindex", 0);
                    if(first_h == true){
                        continue;
                    }
                    var text = $(this).find("h" + i).first().text();
                    $(this).attr("aria-label", text.trim());
                    first_h = true;
                }
            }
            $("p").attr("tabindex", 0);
            $("table").attr("tabindex", 0);
        });
        
        // generate skip links from content -------->
        $("#the_content section").each(function(i, item) {
            let $this = $(this);
            
            var container_class_name = $(this).attr('class');

            if (!container_class_name) {
                container_class_name = "no-class";
            }

            container_class_name = container_class_name.replace(/ /g,'_')+"_"+i;

            if(!$(this).attr("id")){
                $(this).attr("id", container_class_name);
            }else{
                container_class_name = $(this).attr("id");
            }

            var text = $(this).find("h1").text();

            if (!text) {
                text = $(this).attr("aria-label");
            }

            if(typeof text !== "undefined" && text.length > 0){
                $( "#skip-nav" ).append(
                    $( "<div class='skip-link_wr'> <a aria-label='"+text+"' href='#"+container_class_name+"' tabindex='1' class='skip-link'>"+text+"</a>" )
                );
            }
        });

        $(".skip-link").on("keydown", function(e) {
            if(e.which == 13) {
                var id = $(this).attr("href");
                $(id).focus();
            }
        });

        $("body").on("keyup", function(e) {
            if(e.which == 9) {

                let focusedElement = $(":focus")?.[0];
                let isContains = $("#interaktiv_terkep").length > 0 ? $.contains( $("#interaktiv_terkep")?.[0], focusedElement ) : false;
                
                if( isContains ) return;

                let focusedElementContainer = $(focusedElement).closest('footer, section, nav, [class$="skip-link"]');

                // if ($(".open-map").find($this).length <= 0) {
                    let focusedColor = $(focusedElementContainer).css("background-color");
                    // // var focused_element_section_background_color = $(":focus").closest($('section, nav, footer, [class$="skip-link"]')).css("background-color");

    
                    if(focusedColor === "rgba(0, 0, 0, 0)"){
                         focusedColor = $("body").css("background-color");
                    }
                    
                    var hex = rgb2hex( focusedColor ).replace(/#/g,'');
                    var inverted_hex = invertHex(hex);
    
                    $(".focused-element").attr("style", ""); 
                    $(".focused-element").removeClass("focused-element");
                    $(":focus").addClass("focused-element");
                    let border = `border:3px solid #${inverted_hex} !important`;
                    $(":focus").attr("style", border); 
                    
                // }
               
            }
        });

        // navbar submenus tab fix -------->
        $(".navbar-nav li div.megamenu li a").each(function(i, item) {
            $(this).attr("tabindex", "-1");
        });

        $(".megamenu-opener").on("keydown", function(e) {
            if(e.which == 13) {
                var megamenu_id = $(this).attr("data-opener");

               

                $("#"+megamenu_id+" ul li a").each(function(i, item) {
                    $(this).attr("tabindex", "0");
                });
            }
        });

        // checkbox and radio tab fix -------->

        // checkbox tabindex
        var checkbox = "input[type=checkbox]";
        $(checkbox).each(function(i, item) {
            $(this).attr("tabindex", "0");
        });
    });
})(jQuery);